export const MINIMUM_CHARGE_IN_CENTS = 50;
export const MAXIMUM_CHARGE_IN_CENTS = 1000000;
